var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3103 4.87844L14.1216 0.68875C13.8402 0.407371 13.4587 0.249289 13.0608 0.249289C12.6629 0.249289 12.2813 0.407371 12 0.68875L0.439687 12.25C0.157107 12.5303 -0.00127172 12.9123 0 13.3103V17.5C0 18.3284 0.671573 19 1.5 19H5.68969C6.08773 19.0013 6.46966 18.8429 6.75 18.5603L18.3103 7C18.5917 6.71869 18.7498 6.3371 18.7498 5.93922C18.7498 5.54133 18.5917 5.15975 18.3103 4.87844ZM1.81031 13L9.75 5.06031L11.3147 6.625L3.375 14.5637L1.81031 13ZM1.5 14.8103L4.18969 17.5H1.5V14.8103ZM6 17.1897L4.43531 15.625L12.375 7.68531L13.9397 9.25L6 17.1897ZM15 8.18969L10.8103 4L13.0603 1.75L17.25 5.93875L15 8.18969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreator);
export default __webpack_public_path__ + "static/media/creator.bd8e5e1b42635f35d114b9af587fe242.svg";
export { ForwardRef as ReactComponent };